import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import "../styles/Footer.css";

// Import the whole package.json as default
import pkg from "../../package.json"; // adjust path as needed
import { CLUB_EMAIL, CLUB_INSTAGRAM_LINK_HREF, CLUB_INSTAGRAM_NAME, CLUB_LINKTREE_LINK_HREF } from "../constants";
import Icon from "./Icon";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Row>
      <footer className="BREIKKI-footer">
        <Row className="BREIKKI-footer-text-groups-container">
          <Col className="BREIKKI-footer-text-group">
            <p className="BREIKKI-footer-text">{t("club_official_name")}</p>
            <p className="BREIKKI-footer-text">Tampere</p>
            <p className="BREIKKI-footer-text">{CLUB_EMAIL}</p>
            <p className="BREIKKI-footer-text">{t("footer_website_version") + " "}{pkg.version}</p>
          </Col>
          <Col className="BREIKKI-footer-text-group">
            <p className="BREIKKI-footer-text"><Icon linktree className={"BREIKKI-footer-icon"} onClick={() => window.open(CLUB_LINKTREE_LINK_HREF, "_blank")} width={100} height={20} /></p>
            <p className="BREIKKI-footer-text BREIKKI-footer-text-nowrap"><Icon IG className={"BREIKKI-footer-icon"} onClick={() => window.open(CLUB_INSTAGRAM_LINK_HREF, "_blank")} width={30} /></p>
          </Col>
        </Row>
      </footer>
    </Row>
  );
};

export default Footer;
